import { GuestInfoDisplayMode } from '@models/guest-info.model';
import { inject, Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class GuestInfoDataSourceStorageService {
  private readonly storageKey = 'guestInfoDataSource';
  private readonly localStorage = inject(LocalStorageService);

  getDataSource(): string {
    const stored = this.localStorage.getItem(this.storageKey);
    return stored || 'user';
  }

  setDataSource(displayMode: GuestInfoDisplayMode): void {
    this.localStorage.setItem(this.storageKey, displayMode);
  }
}
